import '@stoplight/elements-dev-portal/styles.min.css'

import { CONNECTS_API_V2_SLUG } from 'src/constants'
import { FunctionComponent } from 'react'
import { StoplightProject } from '@stoplight/elements-dev-portal'

const ConnectsAPIDocs: FunctionComponent = () => {
  return (
    <>
      <StoplightProject
        basePath={CONNECTS_API_V2_SLUG}
        projectId={process.env.REACT_APP_STOPLIGHT_CONNECTS_API_V2_ID || ''}
      />
    </>
  )
}

export default ConnectsAPIDocs
